import { twMerge } from "tailwind-merge";
import { Type } from "@themes/pollinator/ui/Type";
import {
  SchedulingTimezoneSelect,
  type Props as SchedulingTimezoneSelectProps,
} from "../SchedulingTimezoneSelect";

export type Props = SchedulingTimezoneSelectProps & {
  className?: string;
};

export function SchedulingTimezones({
  className,
  options,
  value,
  onChange,
}: Props) {
  return (
    <div className={twMerge("flex flex-col gap-4 px-4", className)}>
      <Type variant="h4" as="label" htmlFor="timezone">
        Timezone
      </Type>
      <SchedulingTimezoneSelect
        options={options}
        value={value}
        onChange={onChange}
      />
    </div>
  );
}

export default SchedulingTimezones;

